import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import Navbar from '../../components/Navbar/Navbar';
import InsuranceBanner from '../../components/InsuranceBanner/InsuranceBanner';
import PageTitle from '../../components/pagetitle/PageTitle'
import AboutImproved from '../../components/about/about-improved';
import CtafromSection from '../../components/CtafromSection/CtafromSection';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo-2.svg'
import './AboutPage.css'
import '../../components/about/about-improved.css'

// Professional Background Section Component
const ProfessionalBackground = () => {
    return (
        <section className="professional-background section-padding bg-light">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="section-title text-center">
                            <h2>Medical Leadership & Expertise</h2>
                            <p>Led by Dr. Eugene G. Pereira - Over 25 Years of Clinical Excellence</p>
                        </div>
                    </div>
                </div>
                <div className="row mt-5">
                    <div className="col-lg-6">
                        <div className="credentials-box">
                            <h3>Medical Director's Education & Training</h3>
                            <ul className="timeline-list">
                                <li>
                                    <strong>MD - St. John's Medical College</strong>
                                    <p>Bangalore, India (1991)</p>
                                </li>
                                <li>
                                    <strong>Advanced Stem Cell Training</strong>
                                    <p>Specialized training in regenerative medicine protocols</p>
                                </li>
                                <li>
                                    <strong>Orthobiologic Certification</strong>
                                    <p>Advanced certification in orthobiologic procedures</p>
                                </li>
                                <li>
                                    <strong>Continuous Medical Education</strong>
                                    <p>Regular training in latest regenerative techniques</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="credentials-box">
                            <h3>Clinic Certifications & Accreditations</h3>
                            <ul className="certification-list">
                                <li>
                                    <i className="ti-check"></i>
                                    <strong>Hospital-Grade Sterile Environment</strong>
                                    <p>Exceeding industry standards for patient safety</p>
                                </li>
                                <li>
                                    <i className="ti-check"></i>
                                    <strong>Advanced Laboratory Certification</strong>
                                    <p>State-of-the-art stem cell processing capabilities</p>
                                </li>
                                <li>
                                    <i className="ti-check"></i>
                                    <strong>Comprehensive Insurance Coverage</strong>
                                    <p>Full malpractice and facility insurance</p>
                                </li>
                                <li>
                                    <i className="ti-check"></i>
                                    <strong>Multi-State Medical Licensing</strong>
                                    <p>Licensed in Florida, New York, New Jersey, and Utah</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="row mt-5">
                    <div className="col-lg-12">
                        <div className="hospital-affiliations text-center">
                            <h3>Our Facility & Technology</h3>
                            <div className="row mt-4">
                                <div className="col-md-3">
                                    <div className="hospital-box">
                                        <i className="fa fa-hospital-o"></i>
                                        <h4>Class 5 Clean Room</h4>
                                        <p>Hospital-grade sterile processing environment</p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="hospital-box">
                                        <i className="fa fa-flask"></i>
                                        <h4>Advanced Centrifuge Systems</h4>
                                        <p>Latest technology for optimal cell concentration</p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="hospital-box">
                                        <i className="fa fa-stethoscope"></i>
                                        <h4>Advanced Image Guidance</h4>
                                        <p>State-of-the-art image-guided procedures</p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="hospital-box">
                                        <i className="fa fa-heartbeat"></i>
                                        <h4>Recovery Suite</h4>
                                        <p>Comfortable post-procedure monitoring area</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

// Clinical Philosophy Section Component
const WhyChooseAmped = () => {
    return (
        <section className="why-choose-florida section-padding">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="section-title text-center">
                            <h2>Our Clinical Philosophy & Approach</h2>
                            <p>Transforming Healthcare Through Innovation</p>
                        </div>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-lg-10 offset-lg-1">
                        <div className="philosophy-text text-center mb-5">
                            <p style={{fontSize: '18px', lineHeight: '1.8', color: '#555'}}>
                                At Amped Therapeutics, we believe healing should address root causes, not just symptoms. 
                                Dr. Pereira's approach combines evidence-based regenerative medicine with personalized patient care, 
                                utilizing Florida's advanced regulatory framework and state-of-the-art technology to offer treatments 
                                that restore function and optimize wellness.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="row mt-5">
                    <div className="col-lg-3 col-md-6">
                        <div className="feature-box text-center">
                            <div className="icon">
                                <i className="fas fa-list-check"></i>
                            </div>
                            <h4>Comprehensive Evaluation</h4>
                            <p>Thorough assessment of each patient's unique condition and goals</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div className="feature-box text-center">
                            <div className="icon">
                                <i className="fas fa-person-circle-check"></i>
                            </div>
                            <h4>Personalized Protocols</h4>
                            <p>Tailored treatment plans using the most appropriate regenerative therapies</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div className="feature-box text-center">
                            <div className="icon">
                                <i className="fas fa-medal"></i>
                            </div>
                            <h4>Concierge Excellence</h4>
                            <p>Premium care delivered at optimal Florida locations convenient to you</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div className="feature-box text-center">
                            <div className="icon">
                                <i className="fas fa-hospital-user"></i>
                            </div>
                            <h4>Long-term Partnership</h4>
                            <p>Ongoing support and monitoring throughout your healing journey</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

// New Two Column Section Component
const TwoColumnSection = () => {
    return (
        <section className="two-column-section section-padding" style={{background: 'linear-gradient(135deg, #1AC9A5 0%, #15B093 50%, #0F9681 100%)'}}>
            <div className="container">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="facility-text-block" style={{paddingRight: '40px'}}>
                            <h3 style={{fontSize: '28px', fontWeight: '600', marginBottom: '20px', color: '#ffffff'}}>
                                Advanced Technology & Facilities
                            </h3>
                            <p style={{fontSize: '16px', lineHeight: '1.8', color: '#ffffff'}}>
                                We source our cells and products from Class 5 clean rooms for sterile cellular preparation, 
                                advanced centrifuge systems for optimal cell concentration.
                            </p>
                            <p style={{fontSize: '16px', lineHeight: '1.8', color: '#ffffff', marginTop: '15px'}}>
                                Our therapy is performed using state-of-the-art image guidance for precision delivery, 
                                at AHCA/AASC certified Ambulatory Surgery Centers, under sedation. 
                                These centers are staffed by qualified professionals to ensure your safety and comfort.
                            </p>
                        </div>
                    </div>
                    
                    <div className="col-lg-2 d-flex justify-content-center align-items-center">
                        <div style={{
                            width: '1px',
                            height: '200px',
                            background: 'linear-gradient(180deg, transparent, rgba(255, 255, 255, 0.3), transparent)',
                            margin: '0 20px'
                        }}></div>
                    </div>
                    
                    <div className="col-lg-5">
                        <div className="facility-text-block" style={{paddingLeft: '40px'}}>
                            <h3 style={{fontSize: '28px', fontWeight: '600', marginBottom: '20px', color: '#ffffff'}}>
                                Innovation Meets Accessibility
                            </h3>
                            <p style={{fontSize: '16px', lineHeight: '1.8', color: '#ffffff'}}>
                                We've eliminated the need for international medical tourism by bringing 
                                world-class regenerative medicine with advanced cellular therapies directly 
                                to patients throughout Florida and the Southeast region.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

// State-of-the-Art Facility Section Component
const FacilitySection = () => {
    return (
        <section className="facility-section section-padding bg-light">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="section-title text-center">
                            <h2>Our State-of-the-Art Facility</h2>
                            <p>Purpose-Built for Regenerative Medicine Excellence</p>
                        </div>
                    </div>
                </div>
                <div className="row mt-5">
                    <div className="col-md-3 col-sm-6">
                        <div className="facility-box text-center">
                            <i className="fa fa-hospital-o"></i>
                            <h4>Class 5 Clean Room</h4>
                            <p>Hospital-grade sterile processing environment</p>
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-6">
                        <div className="facility-box text-center">
                            <i className="fa fa-flask"></i>
                            <h4>Advanced Centrifuge</h4>
                            <p>Latest technology for optimal cell concentration</p>
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-6">
                        <div className="facility-box text-center">
                            <i className="fa fa-stethoscope"></i>
                            <h4>Advanced Image Guidance</h4>
                            <p>State-of-the-art image-guided procedures</p>
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-6">
                        <div className="facility-box text-center">
                            <i className="fa fa-heartbeat"></i>
                            <h4>Recovery Suites</h4>
                            <p>Comfortable post-procedure monitoring area</p>
                        </div>
                    </div>
                </div>
                
                {/* Treatment Statistics Section */}
                <div className="row mt-5 pt-5">
                    <div className="col-lg-12">
                        <div className="treatment-stats-wrapper">
                            <div className="row justify-content-center">
                                <div className="col-md-4 col-sm-6">
                                    <div className="stat-box">
                                        <div className="stat-number">25+</div>
                                        <div className="stat-label">Years of Experience</div>
                                    </div>
                                </div>
                                <div className="col-md-4 col-sm-6">
                                    <div className="stat-box">
                                        <div className="stat-number">CERTIFIED</div>
                                        <div className="stat-label">Highest Quality, Ethically Sourced Cells</div>
                                    </div>
                                </div>
                                <div className="col-md-4 col-sm-6">
                                    <div className="stat-box">
                                        <div className="stat-number">24/7</div>
                                        <div className="stat-label">Patient Support</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

const AboutPage = () => {
    return (
        <Fragment>
            <Helmet>
                <title>About Dr. Eugene Pereira | Board-Certified Regenerative Medicine Expert</title>
                <meta name="description" content="Meet Dr. Eugene Pereira, MD - Board-certified pain management physician with 25+ years experience. FIPP & ABIPP certified. Leading expert in regenerative medicine and stem cell therapy in South Florida." />
                <meta name="keywords" content="Dr. Eugene Pereira, board certified pain management, FIPP certified doctor, regenerative medicine doctor, stem cell therapy expert, Florida pain management physician" />
                <meta property="og:title" content="About Dr. Eugene Pereira - Board-Certified Regenerative Medicine Expert" />
                <meta property="og:description" content="25+ years of experience in advanced regenerative medicine. FIPP & ABIPP certified physician leading Amped Therapeutics." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://ampedtherapeutics.com/about" />
                <link rel="canonical" href="https://ampedtherapeutics.com/about" />
            </Helmet>
            <Navbar hclass={'wpo-site-header wpo-site-header-s2'} Logo={Logo} />
            <InsuranceBanner />
            <PageTitle pageTitle={'About Amped Therapeutics'} pagesub={'About'} customClass={'about-hero'} />
            <AboutImproved hclass={'about_section section-padding s4'} />
            <WhyChooseAmped />
            <TwoColumnSection />
            <CtafromSection hclass={'ctafrom_section'} />
            <Footer hclass={'wpo-site-footer'} />
            <Scrollbar />

        </Fragment>
    )
};
export default AboutPage;
